/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceContactTag } from './SourceContactTag';
import {
    SourceContactTagFromJSON,
    SourceContactTagFromJSONTyped,
    SourceContactTagToJSON,
    SourceContactTagToJSONTyped,
} from './SourceContactTag';

/**
 * 
 * @export
 * @interface FindAllSourceContactTags200Response
 */
export interface FindAllSourceContactTags200Response {
    /**
     * 
     */
    data?: Array<SourceContactTag>;
}

/**
 * Check if a given object implements the FindAllSourceContactTags200Response interface.
 */
export function instanceOfFindAllSourceContactTags200Response(value: object): value is FindAllSourceContactTags200Response {
    return true;
}

export function FindAllSourceContactTags200ResponseFromJSON(json: any): FindAllSourceContactTags200Response {
    return FindAllSourceContactTags200ResponseFromJSONTyped(json, false);
}

export function FindAllSourceContactTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceContactTags200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(SourceContactTagFromJSON)),
    };
}

export function FindAllSourceContactTags200ResponseToJSON(json: any): FindAllSourceContactTags200Response {
    return FindAllSourceContactTags200ResponseToJSONTyped(json, false);
}

export function FindAllSourceContactTags200ResponseToJSONTyped(value?: FindAllSourceContactTags200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(SourceContactTagToJSON)),
    };
}

